(() => {
  const groups = {
    "Klassisk rød": ["46320610934977", "46304285655233", "46302594138305", "46302594564289"],
    "Blå": ["46320618012865", "46304285753537", "46302594760897"],
    "Lyserød": ["46320621191361", "46304285720769", "46302595350721"],
    "Hvid": ["46320622305473", "46304285622465", "46302595416257"],
    "Grå": ["46320623059137", "46304286113985", "46302595449025"],
    "Lilla": ["46320625221825", "46304285688001", "46302595481793"]
  };
  const finishes = {"Guld": "46302594498753", "Sølv": "46302594236609", "Rosaguld": "46302594269377"};
  function initialize(gallery) {
    if (gallery.roseFilterReady) return;
    const configElement = gallery.querySelector('[data-rose-gallery-config]');
    if (!configElement) return;
    const config = JSON.parse(configElement.textContent);
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    const list = viewer.querySelector('.product__media-list');
    const thumbnailList = thumbnails?.querySelector('.thumbnail-list');
    const slides = new Map(Array.from(list.children, el => [el.dataset.mediaId.split('-').pop(), el]));
    const thumbs = new Map(Array.from(thumbnailList?.children || [], el => [el.dataset.target.split('-').pop(), el]));
    const section = gallery.closest('[id^="MainProduct"]');
    const form = section?.querySelector('form[id^="product-form-"]:not([id*="installment"])');
    let lastId;
    const originalSetActiveMedia = gallery.setActiveMedia.bind(gallery);
    function apply(variant) {
      if (!variant || !groups[variant.option1]) return;
      const group = groups[variant.option1];
      const bearImages = variant.option2 === "Guld" ? group : group.slice(1).filter(id => id !== "46302594564289");
      const ids = [bearImages[0], finishes[variant.option2], ...bearImages.slice(1)].filter(id => slides.has(id));
      const allowed = new Set(ids);
      for (const [id, slide] of slides) if (!allowed.has(id)) slide.remove();
      for (const [id, thumb] of thumbs) if (!allowed.has(id)) thumb.remove();
      ids.forEach((id, index) => {
        list.append(slides.get(id));
        const thumb = thumbs.get(id);
        if (thumb && thumbnailList) {
          thumbnailList.append(thumb);
          thumb.dataset.mediaPosition = String(index + 1);
          const button = thumb.querySelector('button');
          button.setAttribute('aria-label', button.getAttribute('aria-label').replace(/\d+/, String(index + 1)));
        }
      });
      viewer.sliderItems = viewer.querySelectorAll('[id^="Slide-"]');
      if (viewer.slider) viewer.resetPages();
      if (thumbnails) {
        thumbnails.sliderItems = thumbnails.querySelectorAll('[id^="Slide-"]');
        if (thumbnails.slider) thumbnails.resetPages();
      }
      viewer.querySelectorAll('.slider-counter--total').forEach(el => {el.textContent = String(ids.length);});
      lastId = variant.id;
      originalSetActiveMedia(slides.get(ids[0]).dataset.mediaId, false);
    }
    function currentVariant() {
      const id = Number(form?.querySelector('input[name="id"]')?.value);
      return config.variants.find(v => v.id === id) || config.selected;
    }
    gallery.setActiveMedia = function(mediaId, prepend) {
      if (prepend) {
        apply(currentVariant());
        return;
      }
      if (!list.querySelector('[data-media-id="' + mediaId + '"]')) return;
      originalSetActiveMedia(mediaId, false);
    };
    const onChange = () => {
      setTimeout(() => {
        const variant = currentVariant();
        if (variant.id !== lastId) apply(variant);
      }, 0);
    };
    section?.addEventListener('change', onChange);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (event.data?.variant) apply(event.data.variant);
      });
    }
    gallery.roseFilterReady = true;
    apply(config.selected);
  }
  function start() {
    document.querySelectorAll('media-gallery[data-rose-gallery]').forEach(initialize);
  }
  customElements.whenDefined('media-gallery').then(start);
  document.addEventListener('shopify:section:load', start);
})();